import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RateCeilingDataService } from '../data-services/rate-ceiling';
import { SharedModule } from '../shared';
import { UIRouterModule } from '@uirouter/angular';
import { RateCeilingRoute } from './rate-ceiling.route';
import { EntityDataService } from '@ngrx/data';
import { entityName } from '../data-services/rate-ceiling/rate-ceiling.data-service';

@NgModule({
    providers: [RateCeilingDataService],
    imports: [
      CommonModule,
      SharedModule,
      UIRouterModule.forChild({
        states: [RateCeilingRoute]
      })
    ]
  })
  export class RateCeilingModule {
    constructor(
      entityDataService: EntityDataService,
      rateCeilingService: RateCeilingDataService
    ) {
      entityDataService.registerService(entityName, rateCeilingService);
    }
  }
